module.exports = __webpack_public_path__ + "static/2e854a76c41ea6acf59f312c22dddfe4457b507042ea424d2c3bdf9e73345feb-a7b019905c06ca85963ce348163768d4.png";